import Cookies from 'js-cookie'
import axios from 'axios'
import {
	AUTH_COOKIE_NAME,
	ADMIN_AUTH_COOKIE_NAME,
	AUTHOR_AUTH_COOKIE_NAME,
	ADMANAGER_AUTH_COOKIE_NAME,
} from './auth-cookie'
import { normalizeAxiosError } from './apiError'

const axiosInstance = axios.create({
	baseURL: '/api',
	headers: {
		'Content-Type': 'application/json',
	},
})

axiosInstance.interceptors.request.use(
	(config) => {
		const url = String(config.url || '')
		const isAdmin = url.includes('/admin')
		const isAuthor = url.includes('/author')
		const isAdManager = url.includes('/admanager')
		const token = isAdmin
			? Cookies.get(ADMIN_AUTH_COOKIE_NAME)
			: isAuthor
				? Cookies.get(AUTHOR_AUTH_COOKIE_NAME)
				: isAdManager
					? Cookies.get(ADMANAGER_AUTH_COOKIE_NAME)
					: Cookies.get(AUTH_COOKIE_NAME)
		if (token) {
			config.headers.Authorization = `Bearer ${token}`
		}
		return config
	},
	(error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			const url = String(error.config?.url || '')
			if (url.includes('/admin')) {
				Cookies.remove(ADMIN_AUTH_COOKIE_NAME)
			} else if (url.includes('/author')) {
				Cookies.remove(AUTHOR_AUTH_COOKIE_NAME)
			} else if (url.includes('/admanager')) {
				Cookies.remove(ADMANAGER_AUTH_COOKIE_NAME)
			} else if (
				url.includes('/auth/') ||
				url.includes('/news/author/follow')
			) {
				Cookies.remove(AUTH_COOKIE_NAME)
			}
		}
		return Promise.reject(normalizeAxiosError(error))
	}
)

axios.interceptors.response.use(
	(response) => response,
	(error) => Promise.reject(normalizeAxiosError(error))
)

export default axiosInstance
